import { render } from "./StickyTopPolicyCard.vue?vue&type=template&id=4ec88527&scoped=true"
import script from "./StickyTopPolicyCard.vue?vue&type=script&lang=js"
export * from "./StickyTopPolicyCard.vue?vue&type=script&lang=js"

import "./StickyTopPolicyCard.vue?vue&type=style&index=0&id=4ec88527&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec88527"]])

export default __exports__